import React from 'react'
import {FieldFormElementProps} from "../../../../render/form-elemnent";
import FieldDatetime_FormElementView from "./form-element-view";

const debug = false
// const debug = "FieldTimeOfDay_FormView"

export default function FieldDatetime_FormElement(props:FieldFormElementProps) {

    const onChange = (value: Moment) => {

        if (props.form) {
            props.form.onFormComponentValueChange(props.field.fieldId, value)
        }

    }

    return (
        <FieldDatetime_FormElementView  field     = {props.field}
                                        model     = {props.model}
                                        onChange  = {onChange}
                                        className = {props.className} />
    )

}
